import React, { memo } from 'react';

// eslint-disable-next-line react/display-name
const SvgIconTick = memo(({ id = 'tick-icon', ...props }) => {
    return (
        <svg id={id} width={50} height={50} viewBox='0 0 50 50' {...props}>
            <path d='M44.9 5L15.1 33.2 5.4 21.7 0 26.9l14.5 17.5L50 10.2z' />
        </svg>
    );
});

export default SvgIconTick;
